import styled from "styled-components";
import colors from "../../styles/colors";

export const RegisterPageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: auto;
  background-color: ${colors.theme.galilDark};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    align-items: flex-start;
    padding: 20px 0;
  }

  @media (max-width: 480px) {
    padding: 10px 0;
  }
`;

export const BackgroundImage = styled.img`
  width: 100%;
  bottom: 0;
  position: absolute;
`;

export const GalilLogo = styled.img`
  width: 200px;

  @media (max-width: 768px) {
    width: 150px;
  }

  @media (max-width: 480px) {
    width: 120px;
  }
`;

export const FormWrapper = styled.div`
  width: 90vw;
  max-width: 1200px;
  background: rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10.9px);
  -webkit-backdrop-filter: blur(10.9px);
  border: 1px solid rgba(255, 255, 255, 0.27);
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 100px;
  padding: 40px 120px;
  position: relative;
  z-index: 1;

  @media (max-width: 1024px) {
    gap: 60px;
    padding: 30px 60px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
    padding: 20px;
    width: 95vw;
    align-items: stretch;
    justify-content: flex-start;
    margin: 20px 0;
  }

  @media (max-width: 480px) {
    padding: 15px;
    gap: 20px;
    margin: 10px 0;
  }
`;

export const FormInnerWrapper = styled.form`
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
  button {
    margin-top: 8px;
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
  }

  @media (max-width: 480px) {
    gap: 8px;
    button {
      margin-top: 12px;
      min-height: 44px; /* Touch-friendly button height */
    }
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const TextContainer = styled.div`
    text-align: right;
    direction: rtl;
    color: white;

    @media (max-width: 768px) {
        order: -1; /* Show text above form on mobile */
        margin-bottom: 20px;
        
        h1 {
            font-size: 1.5rem;
            line-height: 1.4;
            margin-bottom: 15px;
        }
        
        h2 {
            font-size: 1.3rem;
            margin: 15px 0 10px 0;
        }
        
        p {
            font-size: 1rem !important;
            line-height: 1.5;
            margin-bottom: 10px;
        }
    }

    @media (max-width: 480px) {
        h1 {
            font-size: 1.3rem;
            line-height: 1.3;
        }
        
        h2 {
            font-size: 1.2rem;
        }
        
        p {
            font-size: 0.9rem !important;
            line-height: 1.4;
        }
    }
`;

export const AlreadyHaveAccount = styled.div`
  box-sizing: border-box;
  text-decoration: underline;
  font-size: 1rem;
  color: ${colors.theme.galilGreen};
  font-weight: normal;
  text-align: center;
  transition: color 0.3s linear;
  cursor: pointer;
  &:hover {
    color: ${colors.theme.galilGreen80};
  }
`;

export const Title = styled.div`
  font-size: 1rem;
  color: ${colors.theme.galilWhite};
  text-align: right;
  padding-top: 8px;
  align-self: flex-end;
`;

export const ErrorMessage = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: red;
  font-size: 1rem;
  font-weight: normal;
  text-align: right;
`;

export const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;
